import React from 'react';

const MainOverview = () => (
  <div />
)

export default MainOverview;
